/*
 * kery: (26/10/2026) fila «Visti da te» in cima alla collezione. Vedi sections/kery-visti-da-te.liquid.
 * Legge gli id salvati da Prestige nella scheda prodotto, chiede le schede a /search (Section Rendering),
 * tiene solo quelle di questa collezione. Ogni errore lascia la sezione nascosta: la pagina non cambia.
 */
(() => {
  const CHIAVE = 'theme:recently-viewed-products';
  const DA_CHIEDERE = 24; // i piu' recenti; poi si filtra per collezione

  function idVisti() {
    try {
      const dati = JSON.parse(localStorage.getItem(CHIAVE) || '[]');
      if (!Array.isArray(dati)) return [];
      return [...new Set(dati.filter((id) => Number.isInteger(id) && id > 0))];
    } catch (e) {
      return []; // JSON rotto o storage bloccato (Safari privato): nessuna fila
    }
  }

  class KeryVistiDaTe extends HTMLElement {
    connectedCallback() {
      if (this._avviato) return;
      this._avviato = true;
      this.querySelector('[data-kvdt-togli]')?.addEventListener('click', () => this.togli());
      this.carica();
    }

    async carica() {
      const collezione = this.dataset.collezione;
      const ids = idVisti().slice(0, DA_CHIEDERE);
      if (!collezione || ids.length === 0) return;

      const max = parseInt(this.dataset.max, 10) || 8;
      const q = ids.map((id) => `id:${id}`).join(' OR ');
      const url = `${window.Shopify?.routes?.root || '/'}search?type=product&q=${encodeURIComponent(q)}&section_id=${encodeURIComponent(this.dataset.sectionId)}`;

      try {
        const risposta = await fetch(url, { priority: 'low' });
        if (!risposta.ok) return;
        const doc = new DOMParser().parseFromString(await risposta.text(), 'text/html');
        const voci = [...doc.querySelectorAll('[data-kvdt-fila] > li')]
          .filter((li) => (li.dataset.collezioni || '').includes(`,${collezione},`))
          .slice(0, max);
        if (voci.length === 0) return;

        this.querySelector('[data-kvdt-fila]').replaceChildren(...voci.map((li) => document.importNode(li, true)));
        this.hidden = false;
      } catch (e) {
        // rete giu' o risposta inattesa: la fila e' un di piu', la collezione resta com'e'
      }
    }

    togli() {
      try {
        localStorage.removeItem(CHIAVE);
      } catch (e) {
        // storage bloccato: basta nascondere la fila
      }
      this.hidden = true;
    }
  }

  if (!customElements.get('kery-visti-da-te')) {
    customElements.define('kery-visti-da-te', KeryVistiDaTe);
  }
})();
